import { IKnmType } from 'APIPackage/CatalogsModule/interfaces/IKnmType';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

export async function fetchKnmTypesAll(): Promise<IKnmType[]> {
  return apiGet<IKnmType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-types/all`);
}

export async function createKnmType(knmType: Omit<IKnmType, 'id'>): Promise<void> {
  return apiPost<void>({ url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-types`, body: knmType });
}

export async function updateKnmType(knmType: IKnmType): Promise<void> {
  const { id, ...data } = knmType;

  return apiPut<void>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-types/${id}`, data);
}
